import { createContext, useContext, ReactNode } from "react";
import { useAuth } from "@/lib/store";

type AuthCtx = ReturnType<typeof useAuth>;
const Ctx = createContext<AuthCtx | null>(null);

export function AuthProvider({ children }: { children: ReactNode }) {
  const value = useAuth();
  return <Ctx.Provider value={value}>{children}</Ctx.Provider>;
}

export function useAuthCtx() {
  const v = useContext(Ctx);
  if (!v) throw new Error("useAuthCtx must be used within AuthProvider");
  return v;
}
